import React from "react";
import { Card } from "antd";
import { Calendar, Clock, MapPin } from "lucide-react";

export default function AbsencesCard() {
  const absencesData = [
    {
      name: "Jennifer Lee",
      employeeId: "EMP003",
      role: "UX Designer",
      department: "Design",
      country: "Philippines",
      flag: "🇵🇭",
      leaveStatus: "On Leave",
      leaveType: "Annual Leave",
      leavePeriod: "Oct 13 - Oct 14, 2025",
      duration: 2,
      reason: "Wedding Attendance",
      returnDate: "Oct 15, 2025",
      statusText: "Currently unavailable",
    },
    {
      name: "Michael Tan",
      employeeId: "EMP007",
      role: "Software Engineer",
      department: "Development",
      country: "Singapore",
      flag: "🇸🇬",
      leaveStatus: "Upcoming",
      leaveType: "Sick Leave",
      leavePeriod: "Nov 5 - Nov 7, 2025",
      duration: 3,
      reason: "Medical Checkup",
      returnDate: "Nov 8, 2025",
      statusText: "Scheduled leave",
    },
        {
      name: "Michael Tan",
      employeeId: "EMP007",
      role: "Software Engineer",
      department: "Development",
      country: "Singapore",
      flag: "🇸🇬",
      leaveStatus: "Upcoming",
      leaveType: "Sick Leave",
      leavePeriod: "Nov 5 - Nov 7, 2025",
      duration: 3,
      reason: "Medical Checkup",
      returnDate: "Nov 8, 2025",
      statusText: "Scheduled leave",
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      {absencesData.map((data, index) => {
        const avatarInitials = data.name
          ? data.name.split(" ").map((n) => n[0]).join("")
          : "";

        return (
          <Card
            key={index}
            className="flex flex-col gap-6 rounded-xl border border-slate-200 hover:shadow-md transition-shadow leave"
          >
            <div className="space-y-4">
              <div className="flex items-start justify-between gap-4">
                <div className="flex items-start gap-3 flex-1">
                  <span className="relative flex w-12 h-12 shrink-0 overflow-hidden rounded-full">
                    <span className="flex size-full items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
                      {avatarInitials}
                    </span>
                  </span>

                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1 flex-wrap">
                      <h4 className="font-semibold">{data.name}</h4>
                      <span className="inline-flex items-center justify-center rounded-xl border px-2 py-0.5 font-medium text-[10px]">
                        {data.employeeId}
                      </span>
                      <span
                        className={`text-[10px] status-indicator ${data.leaveStatus
                          .toLowerCase()
                          .replace(/\s+/g, "-")}`}
                      >
                        {data.leaveStatus}
                      </span>
                    </div>

                    <p className="text-[13px] text-muted-foreground">
                      {data.role} • {data.department}
                    </p>

                    <div className="flex items-center gap-1 mt-1">
                      <MapPin className="w-3 h-3 text-muted-foreground" />
                      <span className="text-[12px] text-muted-foreground mr-1">
                        {data.country}
                      </span>
                      <span className="text-[14px]">{data.flag}</span>
                    </div>
                  </div>
                </div>

                <span
                  className={`font-medium text-[11px] status-indicator ${data.leaveType
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                >
                  {data.leaveType}
                </span>
              </div>

              <div className="h-px w-full bg-border" />

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <p className="text-[11px] text-muted-foreground mb-1">
                    Leave Period
                  </p>
                  <div className="flex items-center gap-2">
                    <Calendar className="w-3 h-3 text-emerald-600" />
                    <span className="text-[13px] font-medium">
                      {data.leavePeriod}
                    </span>
                  </div>
                </div>

                <div>
                  <p className="text-[11px] text-muted-foreground mb-1">
                    Duration
                  </p>
                  <div className="flex items-center gap-2">
                    <Clock className="w-3 h-3 text-purple-600" />
                    <span className="text-[13px] font-medium">
                      {data.duration} days
                    </span>
                  </div>
                </div>

                <div>
                  <p className="text-[11px] text-muted-foreground mb-1">
                    Reason
                  </p>
                  <span className="text-[13px] font-medium">{data.reason}</span>
                </div>
              </div>

              <div className={`status-highlight ${data.leaveStatus.toLowerCase().replace(/\s+/g, "-")}`}>
                <p className="status-text">
                  <span className="font-medium">{data.statusText}</span> – Expected
                  back on {data.returnDate}
                </p>
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
}
